import React from 'react';

import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import ContentSolicitacaoFluxoAprovarArte from './ContentSolicitacaoFluxoAprovarArte';

const SolicitacaoAprovarArte = () => {
  return (
    <div className="d-flex flex-column min-h-screen">
      <HeaderApp />
      <ContentSolicitacaoFluxoAprovarArte />
      <Bottom />
    </div>
  );
};

export default SolicitacaoAprovarArte;
